import React, { memo, useState } from "react";
import ButtonPay from "./ButtonPay";
import payNowIcon from "@img/icons/payNowIcon.png";
import creditCardIcon from "@img/icons/creditCardIcon.png";
import bankIcon from "@img/icons/bankIcon.png";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { OutstandingDataType, SelectedItemType } from "@store/Outstanding";
import { useWidth } from "@utils/demenstion";
import Modal from "@components/modal/Modal";
import { useHistory } from "react-router-dom";

interface PaymentGatwayProps {
  calculationTotal: number;
  selectedItems: SelectedItemType[];
  fetchingCreatePayment: "pending" | "done" | "error";
  onPay: (type: string) => void;
  activeInvoiceTabSection: string;
  messageError: string;
}

const PaymentGatway = ({
  calculationTotal,
  selectedItems,
  fetchingCreatePayment,
  onPay,
  activeInvoiceTabSection,
  messageError,
}: PaymentGatwayProps) => {
  const widthScreen = useWidth();
  let history = useHistory();

  const [showModal, setShowModal] = useState(false);
  const [showStripe, setShowStripe] = useState(false);
  const [isShowBackAccount, setIsShowBackAccount] = useState(false);

  return (
    <>
      {widthScreen < 968 && activeInvoiceTabSection === "0" ? (
        <div
          className={
            widthScreen < 968 && activeInvoiceTabSection === "0"
              ? "fixed bottom-0 z-10 bg-bg_blue w-full mx-auto px-8 pt-2 justify-center flex flex-col items-center"
              : ""
          }
        >
          <div className="w-full mb-4">
            <ButtonPay
              label="Select Payment"
              calculationTotal={calculationTotal}
              selectedItems={selectedItems}
              isLoading={fetchingCreatePayment === "pending"}
              onClick={() => setShowModal(true)}
            />
          </div>
          {/* PayNow */}
          <Modal
            showModal={showModal}
            handleClose={() => setShowModal(false)}
            className="flex flex-col justify-center items-center"
          >
            {/* <div className="w-11/12 mt-20 borderWidth border-slate-50	 rounded-md">
              <ButtonPay
                label="with PayNow"
                icon={<img src={payNowIcon} width="40" height="25" />}
                calculationTotal={calculationTotal}
                selectedItems={selectedItems}
                isLoading={fetchingCreatePayment === "pending"}
                onClick={() => onPay("hitpay")}
              />
            </div> */}

            <div className="w-11/12 mt-20 borderWidth border-slate-50 rounded-md	">
              <ButtonPay
                label="with Credit Card"
                icon={<img src={creditCardIcon} width="40" height="25"></img>}
                calculationTotal={calculationTotal}
                selectedItems={selectedItems}
                isLoading={fetchingCreatePayment === "pending"}
                onClick={() => {
                  setShowStripe(true);
                  setShowModal(false);
                  onPay("stripe");
                }}
              />
            </div>
            <p className="text-red-500 text-center p-2 text-xl">
              Transition Fees are wholly paid to the Payment Gateway provider,
              Stripe. Ling Wei Transport does not receive any transaction fee.
            </p>
            {selectedItems.length !== 0 && (
              <p className="mt-3 text-bold error">{messageError}</p>
            )}

            <div className="borderWidth border-blue-800 mb-8 mt-2 w-11/12" />

            {/* Bank Tranfer */}
            <div className="w-11/12 mb-14 borderWidth border-slate-50 rounded-md	">
              <div
                className="bg-white py-8 px-4 rounded-lg cursor-pointer w-full flex flex-row"
                onClick={() => {
                  setIsShowBackAccount(!isShowBackAccount);
                }}
              >
                <div className="space-x-4 flex flex-row justify-center w-11/12">
                  <img src={bankIcon} width="25" height="25"></img>
                  <h3 className="text-2xl font-semibold text-bahama_blue_hover text-center flex items-center">
                    Pay with Bank Account
                  </h3>
                </div>
                <div className="w-1/12 flex justify-center items-center">
                  {isShowBackAccount ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </div>
              </div>
              {isShowBackAccount && BankInfoRender()}
            </div>
          </Modal>
        </div>
      ) : (
        <div className="md:w-4/12 w-full md:relativ">
          <div className="bg-gray-100 p-7 rounded-lg">
            {/* PayNow */}
            {/* <div className="w-full mb-4">
            <ButtonPay
              label="with PayNow"
              icon={<img src={payNowIcon} width="40" height="25" />}
              calculationTotal={calculationTotal}
              selectedItems={selectedItems}
              isLoading={fetchingCreatePayment === "pending"}
              onClick={() => onPay("hitpay")}
            />
          </div> */}
            <div className="w-full">
              <ButtonPay
                label="with Credit Card"
                icon={<img src={creditCardIcon} width="40" height="25"></img>}
                calculationTotal={calculationTotal}
                selectedItems={selectedItems}
                isLoading={fetchingCreatePayment === "pending"}
                onClick={() => onPay("stripe")}
              />
            </div>
            <p className="text-red-500 text-center p-2 text-xl">
              Transition Fees are wholly paid to the Payment Gateway provider,
              Stripe. Ling Wei Transport does not receive any transaction fee.
            </p>
            {selectedItems.length !== 0 && (
              <p className="mt-3 text-bold error">{messageError}</p>
            )}

            <div className="borderWidth border-blue-800 mb-8 mt-2" />

            {/* Bank Tranfer */}
            <div className="w-full">
              <div
                className="bg-white py-8 px-4 rounded-lg cursor-pointer w-full flex flex-row"
                onClick={() => {
                  setIsShowBackAccount(!isShowBackAccount);
                }}
              >
                <div className="space-x-4 flex flex-row justify-center w-11/12">
                  <img src={bankIcon} width="25" height="25"></img>
                  <h3 className="text-2xl font-semibold text-bahama_blue_hover text-center flex items-center">
                    Pay with Bank Account
                  </h3>
                </div>
                <div className="w-1/12 flex justify-center items-center">
                  {isShowBackAccount ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </div>
              </div>
              {isShowBackAccount && BankInfoRender()}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default memo(PaymentGatway);

const BankInfoRender = () => {
  return (
    <div className="bg-gray-200 p-6">
      <div className="flex flex-row justify-between mb-3">
        <h1 className="font-bold text-bahama_blue_hover">Bank name</h1>
        <h1 className="font-bold">DBS Bank</h1>
      </div>

      <div className="flex flex-row justify-between mb-3">
        <h1 className="font-bold text-bahama_blue_hover">Account</h1>
        <h1 className="font-bold">072-032097-2</h1>
      </div>

      <div className="flex flex-row justify-between mb-3">
        <h1 className="font-bold text-bahama_blue_hover">Swift code</h1>
        <h1 className="font-bold">DBSSSGSG</h1>
      </div>

      <div className="flex flex-row justify-between mb-3">
        <h1 className="font-bold text-bahama_blue_hover">Bank code</h1>
        <h1 className="font-bold">7171</h1>
      </div>

      <div className="flex flex-row justify-between mb-3">
        <h1 className="font-bold text-bahama_blue_hover w-1/2">Bank address</h1>
        <h1 className="font-bold w-1/2 text-right">
          12 Marina Boulevard DBS Asia Central Marina Bay Financial Center Tower
          3 Singapore 018982
        </h1>
      </div>
    </div>
  );
};
